var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI icon/trophy/light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83325 3.33268H14.1666V8.33268C14.1666 10.6339 12.3011 12.4993 9.99992 12.4993C7.69873 12.4993 5.83325 10.6339 5.83325 8.33268V3.33268ZM4.16658 3.33268C4.16658 2.41221 4.91278 1.66602 5.83325 1.66602H14.1666C15.0871 1.66602 15.8333 2.41221 15.8333 3.33268H17.4999C18.4204 3.33268 19.1666 4.07887 19.1666 4.99935V6.66602C19.1666 8.50697 17.6742 9.99935 15.8333 9.99935H15.5917C14.9513 12.1509 13.1031 13.7823 10.8333 14.1069V16.666H13.3333C13.7935 16.666 14.1666 17.0391 14.1666 17.4993C14.1666 17.9596 13.7935 18.3327 13.3333 18.3327H6.66658C6.20635 18.3327 5.83325 17.9596 5.83325 17.4993C5.83325 17.0391 6.20635 16.666 6.66658 16.666H9.16658V14.1069C6.89678 13.7823 5.04849 12.1509 4.40815 9.99935H4.16658C2.32564 9.99935 0.833252 8.50697 0.833252 6.66602V4.99935C0.833252 4.07887 1.57944 3.33268 2.49992 3.33268L4.16658 3.33268ZM4.16658 4.99935H2.49992V6.66602C2.49992 7.58649 3.24611 8.33268 4.16658 8.33268V4.99935ZM15.8333 4.99935V8.33268C16.7537 8.33268 17.4999 7.58649 17.4999 6.66602V4.99935H15.8333Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.f07d332a5bd1c2db2769a5bc42bcd02a.svg";
export { ForwardRef as ReactComponent };